import React, { useState, createContext, useMemo, useContext } from 'react'
import { getActivities, getActivity } from 'api/bank'
import { getActivityDetailsByType } from 'utils/bank'
import { DateToUTC, add, dateFormat } from '../utils'
import { MeContext } from './me'

export const MovementsContext = createContext()

export const MovementsProvider = (props) => {
  const [loading, setLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const [isError, setIsError] = useState(null)

  const [pagination, setPagination] = useState()
  const [activities, setActivities] = useState()
  const [dateRange, setDateRange] = useState({
    created_from: DateToUTC(add(new Date(), { days: -7 })),
    created_until: new Date()
  })

  const [isSettingCurrentActivity, setIsSettingCurrentActivity] =
    useState(false)
  const [currentActivityDetails, setCurrentActivityDetails] = useState()

  const [amountBalance, setAmountBalance] = useState(0)

  const { me } = useContext(MeContext)

  const callActivities = ({ walletUUID }) => {
    if (!walletUUID) return
    setLoading(true)
    const params = {
      pageNumber: 0,
      created_from: dateRange.created_from
        ? dateRange.created_from
        : DateToUTC(add(new Date(), { days: -7 })),
      created_until: dateRange.created_until ? dateRange.created_until : ''
    }
    getActivities(params, walletUUID)
      .then((res) => {
        setActivities(res.data)
        setPagination(res.meta.pagination)
        setLoading(false)
        setIsDisabled(false)
      })
      .catch((error) => {
        setLoading(false)
        setIsError(error)
      })
  }

  const callActivitiesNextPage = ({ walletUUID }) => {
    if (!walletUUID) return
    setLoading(true)
    const params = {
      pageNumber: pagination?.current_page + 1,
      created_from: dateRange.created_from,
      created_until: dateRange.created_until
    }
    getActivities(params, walletUUID)
      .then((res) => {
        setPagination(res.meta.pagination)
        setActivities((prevState) => [...prevState, ...res.data])
        if (res.meta.pagination.total_pages === '1') {
          setIsDisabled(true)
        } else {
          setIsDisabled(false)
        }
        setIsDisabled(false)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setIsError(error)
      })
  }

  const getActivityById = (id) => {
    if (!id) return
    setIsSettingCurrentActivity(true)
    getActivity(id)
      .then((data) => {
        setCurrentActivityDetails(
          getActivityDetailsByType(data, me?.bank?.internal_account[0]?.cvu)
        )
      })
      .finally(() => {
        setIsSettingCurrentActivity(false)
      })
  }

  const options = useMemo(
    () => ({
      pagination,
      activities,
      loading,
      isDisabled,
      setPagination,
      setDateRange,
      dateRange,
      callActivities,
      callActivitiesNextPage,
      getActivityById,
      isSettingCurrentActivity,
      currentActivityDetails,
      setAmountBalance,
      amountBalance,
      isError
    }),
    [
      pagination,
      activities,
      loading,
      isDisabled,
      dateRange,
      callActivities,
      isSettingCurrentActivity,
      currentActivityDetails,
      setAmountBalance,
      amountBalance,
      isError
    ]
  )
  return (
    <MovementsContext.Provider
      value={options}
      {...props}
      displayName='MovementsContext'
    />
  )
}
